import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { enum_api_uri } from "../../../utils/enum";
import { useAuthStore } from "../../../../../console/store/useAuthStore";

interface DeleteCustomerSenderParams {
    customerId: number;
    senderId: number;
}

export const useDeleteCustomerSender = (
    successCallback?: () => void,
): UseMutationResult<null, Error, DeleteCustomerSenderParams, unknown> => {
    const queryClient = useQueryClient();
    const accessToken = useAuthStore(state => state.accessToken);

    return useMutation<null, Error, DeleteCustomerSenderParams>({
        mutationFn: async ({ customerId, senderId }: DeleteCustomerSenderParams) => {
            const response = await axios.delete(
                enum_api_uri.delete_customer_sender
                    .replace(":customer_idx", customerId.toString())
                    .replace(":sender_idx", senderId.toString()),
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                },
            );
            return response.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["getCustomerSender"] });
            successCallback?.();
        },
    });
};
